<template>
<div class="chapter">
<div class="inner_page">
<p class="dedic"><a id="page_5">This book is dedicated to my husband,<br/>Jonathan Cohen, and to Nancy Bare and<br/>Lynn Cohen, two indispensable “Ys”<br/>in our own DIY wedding.</a></p><a id="page_5">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?1bae8b2a